import "../components/style/style.css";
import logo from "../assets/logo.png";
import { useEffect, useMemo, useState } from "react";

const routes = {
  home: "/",
  about: "/about",
  rights: "/terms-and-conditions",
  grievance: "/complain-form",
  laws: "/faq",
  management: "/our-management-body",
  team: "/our-members",
  projects: "/success-story",
  press: "/news-post",
  gallery: "/photo-gallery",
  contact: "/contact",
  donate: "/user-donate",
  register: "/member-registration",
  login: "/login",
  complaint: "/complain-form",
  documents: "/idcard-download",
  terms: "/terms-and-conditions",
  refund: "/cancellation-and-refund-policy",
  privacy: "/privacy-policy",
};

const QuickIdIcon = () => (
  <svg width="86" height="86" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
    <circle cx="9" cy="12" r="2.4" fill="currentColor" />
    <path d="M5.5 17c1.2-2 6.3-2 7.5 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M14 10h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M14 13h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M14 16h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const QuickPdfIcon = () => (
  <svg width="86" height="86" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z" stroke="currentColor" strokeWidth="2"/>
    <path d="M14 2v5h5" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 17c2-4 3-7 5-7 1.2 0 1.6 1.4-.2 3.4 1.8 0 3.2.7 3.2 1.7 0 1.2-2 .8-4.3-.7-1.6 1.7-3 2.7-3.9 2.7-1.2 0-.8-1.3.2-2.4z" fill="currentColor"/>
  </svg>
);

const QuickCertIcon = () => (
  <svg width="86" height="86" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3l1.6 2.2 2.7-.4.8 2.6 2.6.8-.4 2.7L21 12l-2.2 1.6.4 2.7-2.6.8-.8 2.6-2.7-.4L12 21l-1.6-2.2-2.7.4-.8-2.6-2.6-.8.4-2.7L3 12l2.2-1.6-.4-2.7 2.6-.8.8-2.6 2.7.4z" fill="currentColor"/>
  </svg>
);

const QuickDonateIcon = () => (
  <svg width="86" height="86" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 21s-7-4.4-9.2-8.6C1.3 9.3 3 6.8 6 6.8c1.6 0 3 .9 3.7 2 0 0 1.4-2 3.8-2 3 0 4.7 2.5 3.2 5.6C19 16.6 12 21 12 21z" fill="currentColor"/>
    <path d="M4 18h7c1.3 0 2.3-.7 3.1-1.5l3.5-3.4c.7-.7 1.9-.7 2.6 0 .7.7.7 1.9 0 2.6l-3.9 3.8C16.9 21 15 22 13 22H4a2 2 0 0 1-2-2v-2h2z" fill="currentColor" opacity="0.85"/>
  </svg>
);

const DonateEducationIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 6.5C4 5.12 5.12 4 6.5 4H20v15.5a.5.5 0 0 1-.5.5H6.5A2.5 2.5 0 0 1 4 17.5v-11Z"
      fill="currentColor"
      opacity="0.18"
    />
    <path
      d="M6.5 4H20v16H6.5A2.5 2.5 0 0 1 4 17.5V6.5A2.5 2.5 0 0 1 6.5 4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M8 7h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M8 10h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M8 13h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const DonateMedicalIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M8 5h8a2 2 0 0 1 2 2v1H6V7a2 2 0 0 1 2-2Z" fill="currentColor" opacity="0.18" />
    <path d="M6 8h12v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8Z" stroke="currentColor" strokeWidth="2" />
    <path d="M10 3h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M9 14h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const DonateEnvironmentIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
    <path d="M3 12h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 3c3 3.2 3 14.8 0 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 3c-3 3.2-3 14.8 0 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const DonateLegalIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M10 4h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M12 4v10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M7 9h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M6.2 9.2 4 11.4c1.2 1.2 3.2 1.2 4.4 0L6.2 9.2Z" fill="currentColor" opacity="0.22" />
    <path d="M17.8 9.2 20 11.4c-1.2 1.2-3.2 1.2-4.4 0l2.2-2.2Z" fill="currentColor" opacity="0.22" />
    <path d="M4 11.4 6.2 9.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 11.4 17.8 9.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M8 20h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M10 20c0-2 4-2 4 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const DonateSocialIcon = () => (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="8" cy="10" r="2.2" fill="currentColor" opacity="0.22" />
    <circle cx="16" cy="10" r="2.2" fill="currentColor" opacity="0.22" />
    <path
      d="M5 18v-1c0-1.6 1.7-2.8 3.8-2.8S12.6 15.4 12.6 17v1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.4 18v-1c0-1.6 1.7-2.8 3.8-2.8S19 15.4 19 17v1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M11.2 12.8h1.6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default function Home() {
  const slides = useMemo(
    () => [
      {
        image: "/backend/events/1764006498_1.jpg",
      },
      {
        image: "/backend/events/1764006922_1.jpg",
      },
      {
        image: "/backend/events/1764007683_2.jpg",
      },
    ],
    []
  );

  const managementMembers = useMemo(
    () => [
      {
        name: "Ajay Pratap Singh",
        role: "Chairman",
        image: "/frontend/custom/user.png",
      },
      {
        name: "Manoj Kumar Singh",
        role: "National Secretary",
        image: "/frontend/custom/user.png",
      },
      {
        name: "D M Pandey",
        role: "Director General",
        image: "/frontend/custom/user.png",
      },
      {
        name: "Ashish Kumar",
        role: "Joint Director, India",
        image: "/frontend/custom/user.png",
      },
      {
        name: "Shivam Tiwari",
        role: "Director, Delhi",
        image: "/frontend/custom/user.png",
      },
    ],
    []
  );

  const galleryImages = useMemo(
    () => [
      "/backend/gallery/photo/_prd_1669980090.jpeg",
      "/backend/gallery/photo/_prd_1670062713.jpg",
      "/backend/gallery/photo/_prd_1670062756.jpg",
      "/backend/gallery/photo/_prd_1670062807.jpg",
      "/backend/gallery/photo/_prd_1670062868.jpg",
      "/backend/gallery/photo/_prd_1670063041.jpeg",
      "/backend/gallery/photo/_prd_1670064067.jpg",
      "/backend/gallery/photo/_prd_1670064384.jpg",
      "/backend/gallery/photo/_prd_1674126223.png",
      "/backend/gallery/photo/_prd_1676895543.png",
    ],
    []
  );

  const donateCards = useMemo(
    () => [
      { title: "Help For Education", icon: <DonateEducationIcon /> },
      { title: "Help For Medical\nEmergency", icon: <DonateMedicalIcon /> },
      { title: "Help For Environment\nHelp", icon: <DonateEnvironmentIcon /> },
      { title: "Help For Legal Help", icon: <DonateLegalIcon /> },
      { title: "Help For Social\nReforms", icon: <DonateSocialIcon /> },
    ],
    []
  );

  const [activeSlide, setActiveSlide] = useState(0);
  const [baseSlide, setBaseSlide] = useState(0);
  const [fadeVisible, setFadeVisible] = useState(true);

  const goPrev = () => setActiveSlide((i) => (i - 1 + slides.length) % slides.length);
  const goNext = () => setActiveSlide((i) => (i + 1) % slides.length);

  const galleryLoop = useMemo(() => [...galleryImages, ...galleryImages], [galleryImages]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveSlide((i) => (i + 1) % slides.length);
    }, 6500);
    return () => clearInterval(intervalId);
  }, [slides.length]);

  useEffect(() => {
    setFadeVisible(false);
    const rafId = requestAnimationFrame(() => setFadeVisible(true));
    const timeoutId = setTimeout(() => setBaseSlide(activeSlide), 1200);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [activeSlide]);

  return (
    <div className="cb-page" id="top">
      <section
        className="cb-hero"
        aria-label="Hero slider"
      >
        <div className="cb-hero-bg" aria-hidden="true">
          <div className="cb-hero-bg-layer" style={{ backgroundImage: `url(${slides[baseSlide].image})` }} />
          <div
            className="cb-hero-bg-layer cb-hero-bg-layer-fade"
            style={{
              backgroundImage: `url(${slides[activeSlide].image})`,
              opacity: fadeVisible ? 1 : 0,
            }}
          />
        </div>

        <div className="cb-hero-overlay" aria-hidden="true" />

        <button className="cb-hero-arrow cb-hero-arrow-left" type="button" onClick={goPrev} aria-label="Previous slide">
          {"\u2039"}
        </button>
        <button className="cb-hero-arrow cb-hero-arrow-right" type="button" onClick={goNext} aria-label="Next slide">
          {"\u203A"}
        </button>

        <div className="cb-hero-inner">
          <div className="cb-hero-badge">
            <img src={logo} alt="" className="cb-hero-badge-img" />
          </div>

          <div className="cb-hero-kicker">WELCOME TO</div>
          <h2 className="cb-hero-title">Crime Investigation Agency (CIA)</h2>
          <p className="cb-hero-subtitle">
            "Welcome to the Crime Investigation Agency (CIA), a national-level force committed to eradicating crime,
            corruption, and social injustices across India. Join us in our mission to create a safer, more just society
            for all."
          </p>
        </div>
      </section>

      <section className="cb-quicklinks" aria-label="Quick links">
        <div className="cb-quicklinks-titlebar">
          <div className="cb-quicklinks-title">Quick Links</div>
        </div>

        <div className="cb-quicklinks-inner">
          <div className="cb-ql-grid">
            <a className="cb-ql-card" href={routes.documents}>
              <div className="cb-ql-card-title">Generate ID Card</div>
              <div className="cb-ql-card-icon"><QuickIdIcon /></div>
            </a>
            <a className="cb-ql-card" href={routes.documents}>
              <div className="cb-ql-card-title">Appointment Letter</div>
              <div className="cb-ql-card-icon"><QuickPdfIcon /></div>
            </a>
            <a className="cb-ql-card" href={routes.documents}>
              <div className="cb-ql-card-title">Generate Certificate</div>
              <div className="cb-ql-card-icon"><QuickCertIcon /></div>
            </a>
            <a className="cb-ql-card" href={routes.donate}>
              <div className="cb-ql-card-title">Donate Us</div>
              <div className="cb-ql-card-icon"><QuickDonateIcon /></div>
            </a>
          </div>
        </div>
      </section>

      <section className="cb-about" aria-label="About CIA">
        <div className="cb-about-inner">
          <div className="cb-about-left">
            <img src={logo} alt="Crime Investigation Agency" className="cb-about-logo" />
          </div>

          <div className="cb-about-right">
            <h3 className="cb-about-title">About Crime Investigation Agency (CIA)</h3>
            <p className="cb-about-text">
              The Crime Investigation Agency (CIA) is a national-level, non-governmental organization registered under
              the Indian Trust Act of 1882 (Registration No. 817-4-2016). Our mission is to serve as a vigilant force
              dedicated to combating crime, corruption, and social injustices across India. We specialize in a wide
              array of investigative efforts, focusing on crime investigation, corruption detection, human rights
              protection, and addressing the heinous practices of bonded and child labor, as well as police misconduct.
            </p>

            <a className="cb-about-btn" href={routes.about}>
              Know More About Us <span className="cb-about-btn-arrow" aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>

      <section className="cb-goals" aria-label="Goals of Crime Investigation Agency (CIA)">
        <div className="cb-goals-inner">
          <h2 className="cb-goals-title">
            <span className="cb-goals-blue">GOALS OF </span>
            <span className="cb-goals-red">CRIME INVESTIGATION AGENCY (CIA)</span>
          </h2>

          <div className="cb-goals-underline" aria-hidden="true">
            <div className="cb-goals-underline-red" />
            <div className="cb-goals-underline-blue" />
          </div>

          <div className="cb-goals-cards" aria-label="Goals highlights">
            <a className="cb-goal-card" href={routes.about}>
              Combat
              <br />
              Corruption at All
              <br />
              Levels
            </a>
            <a className="cb-goal-card" href={routes.about}>
              Protect Human
              <br />
              Rights
            </a>
            <a className="cb-goal-card" href={routes.about}>
              Enhance Crime
              <br />
              Investigation
              <br />
              Capabilities
            </a>
            <a className="cb-goal-card" href={routes.about}>
              Foster Public
              <br />
              Awareness and
              <br />
              Engagement
            </a>
            <a className="cb-goal-card" href={routes.about}>
              Strengthen
              <br />
              Collaboration with
              <br />
              Law Enforcement
            </a>
            <a className="cb-goal-card" href={routes.about}>
              Promote Social
              <br />
              Welfare and
              <br />
              Justice
            </a>
          </div>

          <div className="cb-goals-content">
            <h3 className="cb-goals-content-title">Goals of Crime Investigation Agency (CIA)</h3>
            <ol className="cb-goals-list">
              <li>
                <strong>Combat Corruption at All Levels:</strong> To aggressively identify, investigate, and expose
                corrupt practices in government, business, and public administration, ensuring that those involved are
                held accountable and brought to justice.
              </li>
              <li>
                <strong>Protect Human Rights:</strong> To safeguard the rights of the vulnerable and marginalized by
                addressing and preventing human rights violations such as bonded labor, child labor, police brutality,
                and gender-based violence.
              </li>
              <li>
                <strong>Enhance Crime Investigation Capabilities:</strong> To continuously improve our investigative
                techniques and methodologies, enabling us to effectively uncover and dismantle criminal networks
                involved in organized crime, smuggling, narcotics trafficking, and other illegal activities.
              </li>
              <li>
                <strong>Foster Public Awareness and Engagement:</strong> To educate and empower citizens to actively
                participate in the fight against crime and corruption through awareness campaigns, workshops, and
                community outreach programs.
              </li>
              <li>
                <strong>Strengthen Collaboration with Law Enforcement:</strong> To build and maintain strong
                partnerships with law enforcement agencies, including the Police, CBI, NIA, and other relevant bodies,
                ensuring coordinated efforts in crime prevention and investigation.
              </li>
              <li>
                <strong>Promote Social Welfare and Justice:</strong> To implement and support social welfare
                initiatives that uplift disadvantaged communities, promote justice, and contribute to the overall
                well-being and safety of society.
              </li>
            </ol>
          </div>
        </div>
      </section>
      <section className="cb-photo-slider" aria-label="Photo slider">
        <div className="cb-photo-frame">
          <div className="cb-photo-side cb-photo-side-left" aria-hidden="true">
            <div className="cb-photo-bg-layer" style={{ backgroundImage: `url(${slides[baseSlide].image})` }} />
            <div
              className="cb-photo-bg-layer cb-photo-bg-layer-fade"
              style={{
                backgroundImage: `url(${slides[activeSlide].image})`,
                opacity: fadeVisible ? 1 : 0,
              }}
            />
          </div>

          <div className="cb-photo-center">
            <div className="cb-photo-center-inner">
              <div className="cb-photo-img-layer" aria-hidden="true" style={{ backgroundImage: `url(${slides[baseSlide].image})` }} />
              <div
                className="cb-photo-img-layer cb-photo-img-layer-fade"
                style={{
                  backgroundImage: `url(${slides[activeSlide].image})`,
                  opacity: fadeVisible ? 1 : 0,
                }}
              />
            </div>
          </div>

          <div className="cb-photo-side cb-photo-side-right" aria-hidden="true">
            <div className="cb-photo-bg-layer" style={{ backgroundImage: `url(${slides[baseSlide].image})` }} />
            <div
              className="cb-photo-bg-layer cb-photo-bg-layer-fade"
              style={{
                backgroundImage: `url(${slides[activeSlide].image})`,
                opacity: fadeVisible ? 1 : 0,
              }}
            />
          </div>
        </div>
      </section>

      <section className="cb-mgmt" aria-label="Our management body">
        <div className="cb-mgmt-inner">
          <h2 className="cb-mgmt-title">
            <span className="cb-mgmt-blue">OUR MANAGEMENT </span>
            <span className="cb-mgmt-red">BODY</span>
          </h2>

          <div className="cb-goals-underline" aria-hidden="true">
            <div className="cb-goals-underline-red" />
            <div className="cb-goals-underline-blue" />
          </div>

          <div className="cb-mgmt-grid" aria-label="Management members">
            {managementMembers.map((member) => (
              <a className="cb-mgmt-card" href={routes.management} key={`${member.name}-${member.role}`}>
                <div className="cb-mgmt-photo-wrap">
                  <img className="cb-mgmt-photo" src={member.image} alt={member.name} />
                </div>

                <div className="cb-mgmt-card-body">
                  <div className="cb-mgmt-name">{member.name}</div>
                  <div className="cb-mgmt-role">({member.role})</div>
                  <div className="cb-mgmt-org">Crime Investigation Agency</div>
                </div>
              </a>
            ))}
          </div>

          <div className="cb-mgmt-cta">
            <a className="cb-mgmt-btn" href={routes.management}>
              See Full Management Body <span className="cb-mgmt-btn-ic" aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>

      <section className="cb-gallery" aria-label="Our gallery">
        <div className="cb-gallery-inner">
          <h2 className="cb-gallery-title">
            <span className="cb-gallery-blue">OUR </span>
            <span className="cb-gallery-red">GALLERY</span>
          </h2>

          <div className="cb-goals-underline" aria-hidden="true">
            <div className="cb-goals-underline-red" />
            <div className="cb-goals-underline-blue" />
          </div>

          <div className="cb-gallery-marquee" aria-label="Gallery marquee">
            <div className="cb-gallery-track" aria-hidden="true">
              {galleryLoop.map((src, index) => {
                const pattern = index % 4;
                const sizeClass =
                  pattern === 0 ? "cb-gallery-card-sm" : pattern === 3 ? "cb-gallery-card-edge" : "cb-gallery-card-lg";

                return (
                  <a className={["cb-gallery-card", sizeClass].join(" ")} href={routes.gallery} key={`${src}-${index}`}>
                    <img className="cb-gallery-img" src={src} alt="" />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="cb-gallery-cta">
            <a className="cb-gallery-btn" href={routes.gallery}>
              See More Images <span className="cb-gallery-btn-ic" aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>

      <section className="cb-donate-smile" aria-label="Donate for smile">
        <div className="cb-donate-inner">
          <h2 className="cb-donate-title">
            <span className="cb-donate-blue">DONATE </span>
            <span className="cb-donate-red">FOR SMILE</span>
          </h2>

          <div className="cb-goals-underline" aria-hidden="true">
            <div className="cb-goals-underline-red" />
            <div className="cb-goals-underline-blue" />
          </div>

          <div className="cb-donate-grid" aria-label="Donate categories">
            {donateCards.map((card) => (
              <article className="cb-donate-card" key={card.title}>
                <div className="cb-donate-ic">{card.icon}</div>
                <div className="cb-donate-card-title">
                  {card.title.split("\n").map((line, idx, arr) => (
                    <span key={idx}>
                      {line}
                      {idx < arr.length - 1 ? <br /> : null}
                    </span>
                  ))}
                </div>
                <a className="cb-donate-now" href={routes.donate}>Donate Now</a>
              </article>
            ))}
          </div>

          <div className="cb-donate-cta">
            <a className="cb-donate-contact" href={routes.contact}>
              Contact Us Now <span className="cb-donate-contact-ic" aria-hidden="true">→</span>
            </a>
          </div>

          <div className="cb-donate-social">
            <div className="cb-donate-social-title">Follow Us On Social Media</div>
            <div className="cb-donate-social-icons" aria-label="Social media">
              <button className="cb-donate-social-btn" type="button" aria-label="Facebook">f</button>
              <button className="cb-donate-social-btn" type="button" aria-label="X">X</button>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
